<template>
  <div class="fill-height">
    <v-card
        height="100%"
        class="rounded-lg"
    >
      <div class="d-flex justify-space-between align-center">
        <v-card-title class="text-break link-on-hover"><strong>{{ $t('cards.titles.continueJourney') }}</strong></v-card-title>
        <!--<v-btn
            disabled
            text
            color="primary"
            class="mx-4"
            @click.prevent="navigate('/browse')"
            v-if="!$vuetify.breakpoint.mobile"
        >
          {{ $t('buttons.browse') }}
          <v-icon
              right
              dark
          >
            fal fa-chevron-right
          </v-icon>
        </v-btn>-->
      </div>
        <v-card-text v-if="isLoading" class="d-flex justify-start flex-wrap">
            <template v-for="n in 4">
                <div class="col-12 col-sm-6 col-lg-3 ma-0 pa-2" :key="n">
                    <v-card
                            class="ma-2 my-0 rounded-lg"
                            color="transparent"
                            flat
                    >
                        <v-skeleton-loader
                                type="image"
                        ></v-skeleton-loader>
                    </v-card>
                </div>
            </template>
        </v-card-text>
        <v-card-text v-if="!isLoading && !children" class="d-flex justify-center align-center">
            <div class="my-6 fill-height">{{ $t('cards.texts.comingSoon') }}</div>
        </v-card-text>
        <v-card-text v-if="!isLoading" class="px-2 py-0 d-flex flex-wrap">
            <template v-for="(child, n) in children">
                <div :key="'bestChoice-' + child.identifier" class="col-12 col-sm-6 col-lg-3 pa-0 px-2" v-if="n < 4">
                    <v-card
                            class="ma-2 my-0"
                            color="transparent"
                            flat
                            tile
                            height="100%"
                            link
                            @click.prevent="navigate('/content/' + child.identifier)"
                    >
                        <v-hover v-slot="{ hover }">
                            <v-img
                                    :src="child.asset.properties.thumbnailUrl"
                            >
                                <v-chip
                                        v-if="child.asset.properties.duration"
                                        class="ma-2 rounded-lg"
                                        label
                                        small
                                        color="primary"
                                >
                                    {{ child.asset.properties.duration.substring(0, 3) === '00:' ? child.asset.properties.duration.substring(3) : child.asset.properties.duration }}
                                </v-chip>
                                <v-fade-transition v-if="child.asset.system === 'VIMEO' && hover">
                                    <v-overlay
                                            v-if="hover"
                                            absolute
                                            color="black"
                                    >
                                        <v-icon
                                                color="primary"
                                                large
                                        >
                                            fas fa-play
                                        </v-icon>
                                    </v-overlay>
                                </v-fade-transition>
                            </v-img>
                        </v-hover>
                        <v-card-text class="d-flex justify-space-between align-start">
                            <div>
                                <div v-if="child.asset.properties.title"><strong>{{ child.asset.properties.title }}</strong></div>
                                <!--<div v-if="serie.type === 'video' && serie.episodeNumber">{{ $t('labels.episode') }} {{ serie.episodeNumber }}</div>
                                <div v-if="serie.type === 'file' && serie.size">{{ serie.size.formatted }}</div>-->
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </template>
        </v-card-text>
<!--      <v-card-text v-if="!isLoading" class="px-2 pt-0 d-flex">
        <div v-for="n in 4" :key="'continuejourney-' + n" class="col-3 pa-0 px-2">
          <v-img
              src="https://vhx.imgix.net/movetohappiness/assets/8ac39561-441b-4822-8042-b34cfc206cec.jpg?auto=format%2Ccompress&fit=crop&h=360&q=70&w=640"
          ></v-img>
          <div><strong>How to got back in shape</strong></div>
          <div>1 season</div>
        </div>
      </v-card-text>-->
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-continue-journey",
  data() {
    return {
      isLoading: false,
      children: []
    }
  },

  mounted(){
    this.fetchLatest()
  },
  
  methods: {
    async fetchLatest(){
      this.isLoading = true
      let latestFromVimeo = await api.watch.getLatestVimeo().then((res) => { return res.data })
      if (latestFromVimeo.result){
          latestFromVimeo = latestFromVimeo.result.collections.map((x) => {
              return x.id
          })
          let latestStructure = await api.structures.getLatestStructuresFromVimeo(latestFromVimeo).then((res) => { return res.data })
          if (latestStructure){
              latestStructure = latestStructure.filter((x) => { return x.language === this.$i18n.locale })
              this.children = latestStructure.reverse()
          }
        // this.categories = categories
      }
      this.isLoading = false
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
  }
}
</script>

<style scoped>

</style>
